import { pxToRem, responsiveFontSizes } from "src/utils/helper/getFontValue";

const typography = {
  fontFamily: "DanaFaNum",
  fontWeightRegular: 500,
  fontWeightMedium: 600,
  fontWeightBold: 700,

  h1: {
    fontWeight: 700,
    fontSize: pxToRem(72),
    letterSpacing: 0,
  },
  h2: {
    fontWeight: 700,
    fontSize: pxToRem(64),
  },
  h3: {
    fontWeight: 700,
    fontSize: pxToRem(56),
  },
  h4: {
    fontWeight: 700,
    fontSize: pxToRem(48),
  },
  h5: {
    fontWeight: 700,
    fontSize: pxToRem(32),
  },
  h6: {
    fontWeight: 700,
    ...responsiveFontSizes({ sm: 20, md: 24, lg: 24 }),
  },
 title: {
    fontWeight: 700,
    fontSize: pxToRem(20),
  },
  subtitle1: {
    fontWeight: 500,
    fontSize: pxToRem(20),
  },
  subtitle2: {
    fontWeight: 500,
    fontSize: pxToRem(18),
  },
  body1: {
    fontWeight: 500,
    fontSize: pxToRem(16),
  },
  body2: {
    fontWeight: 500,
    fontSize: pxToRem(14),
  },
  caption: {
    fontWeight: 500,
    fontSize: pxToRem(12),
  },
  overline: {
    fontWeight: 700,
    fontSize: pxToRem(12),
    textTransform: "uppercase",
  },
  buttonSmall: {
    fontWeight: 700,
    fontSize: pxToRem(12),
  },
  buttonLarge: {
    fontWeight: 700,
    fontSize: pxToRem(14),
  },
  tiny: {
    fontWeight: 400,
    lineHeight: 1.5,
    fontSize: pxToRem(9),
  },
  banner: {
    fontWeight: 700,
    ...responsiveFontSizes({ sm: 10, md: 14, lg: 18 }),
  },
};

export default typography;

export const inputTitle = {
  fontFamily: "DanaFaNum",
  fontSize: 14,
  lineHeight: "20px",
  fontWeight: 700,
  wordSpacing: 1.2,
};
